export class OfferStatus {
    public static getStatus(val: number) {
        switch (val) {
            case 0: return 'common.pending';
            case 1: return 'common.approved';
            case 2: return 'common.disapproved';
        }
    }
}
